export const lb = {
    LEFT: 'Lénks: geet zum viregten Dag.',
    RIGHT: 'Riets: Réckelen op den nächsten Dag.',
    DOWN: 'Ënnen: Réckelen Si an d \' nächst Zeil.',
    UP: 'Uewen: d zur viregten Zeil.',
    PGUP: 'Bild: Bewegen zum viregten Mount.',
    PGDOWN: 'Bild↓: Bewege Si sech op den nächste Mount.',
    HOME: 'Home: zu dem viregten Joer.',
    END: 'Enn: Réckelen op d \' nächst Joer.',
    ESC: 'Esc//Haut / close: Zoumaachen vum Kalenner.',
    TITLE: 'Tastatur-Uweisung'
};
